import React from "react";
import { FaGithub, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { SiHashnode } from "react-icons/si";
import { profile } from "../../constants";

const SocialIcons = () => {
  const links = [
    { href: profile.social.github, label: "GitHub", icon: <FaGithub /> },
    { href: profile.social.linkedin, label: "LinkedIn", icon: <FaLinkedinIn /> },
    { href: profile.social.twitter, label: "X (Twitter)", icon: <FaTwitter /> },
    { href: profile.social.hashnode, label: "Hashnode", icon: <SiHashnode /> },
    { href: `mailto:${profile.email}`, label: "Email", icon: <MdEmail /> },
  ].filter(({ href }) => href);

  return (
    <div className="flex gap-4">
      {links.map(({ href, label, icon }) => (
        <a
          key={label}
          href={href}
          target={href.startsWith("mailto:") ? undefined : "_blank"}
          rel="noreferrer"
          aria-label={label}
          title={`${label} · @${profile.handle}`}
          className="bannerIcon"
        >
          {icon}
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
